import Box from "@/common/components/Box";
import ResumeItem from "@/common/components/ResumeItem";
import { formatDateTime } from "@/common/utils/formatters";
import EstablishmentChoiceEntryProposalAwaitingEstablishmentResponse from "./AwaitingEstablishmentResponse";
import EstablishmentChoiceEntryProposalDiagnostic from "./Diagnostic";
import { MaintenanceForwardingEstablishmentChoiceEntryProposalData } from "../../../../../../features/forwardings/types/forwardings/establishmentChoiceEntries/establishmentChoiceEntry.type";

interface EstablishmentChoiceEntryProposalProps {
  proposal: MaintenanceForwardingEstablishmentChoiceEntryProposalData;
  showProposalDiagnostic?: boolean;
}

const EstablishmentChoiceEntryProposal = ({ proposal, showProposalDiagnostic }: EstablishmentChoiceEntryProposalProps) => {
  if (proposal.status === 'awaiting_establishment_response') {
    return <EstablishmentChoiceEntryProposalAwaitingEstablishmentResponse />
  }

  return (
    <Box className="p-4 flex flex-col gap-4">
      <div className="flex flex-col gap-3">
        <div>
          <p className="font-semibold">
            Proposta {proposal.id?.split('-')?.[0]?.toUpperCase()}
          </p>
        </div>

        <div className="flex gap-3">
          {proposal?.process_started_at && (
            <ResumeItem
              label="Data do lance"
              value={formatDateTime(new Date(proposal?.process_started_at))}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}
        </div>
      </div>

      {showProposalDiagnostic && (
        <div className="-mx-4 -mb-4">
          <EstablishmentChoiceEntryProposalDiagnostic />
        </div>
      )}
    </Box>
  );
}

export default EstablishmentChoiceEntryProposal;
